// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uRT9","right":"styles_right__260cZ"};